<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-2">
<div class="heading heading-with-title heading-without-image" id="chapter-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">2</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-2-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Shankill Road,</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>Belfast, Northern Ireland</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>March 1970</b></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width"><span class="drop-cap">T</span>he red brick back-yard wall of McGrew’s Pub looked daunting to such a small boy.</p>
<p class="subsq">Looming above him and bristling with broken shards and slivers from the multi-coloured glass of bleach bottles and jam jars.</p>
<p class="subsq">Cemented deep in there.</p>
<p class="subsq">Jagging up like shark fins and crooked crocodile teeth.</p>
<p class="subsq">To repel intruders and ten-year-old misfits in pursuit of lost footballs.</p>
<p class="subsq">Eban Winston Barnard was eleven.</p>
<p class="subsq">And fully possessed of his reasons to climb.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-002.vue?3ceb7aae